import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from './TrackingFinanceReturn.module.css';
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import DeskTopBlueMobileWhiteHeader from "@/components/sharedComponents/DeskTopBlueMobileWhiteHeader/DeskTopBlueMobileWhiteHeader";
import useHelpers from "@hooks/useHelpers";
import AnyQuestion from "@/pages/faqs/FaqComponents/AnyQuestion";
import { useTrackingReturnWizard } from "@/pages/tracking/trackingReturn/TrackingReturnWizardContext";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
var TrackingFinanceReturn = function TrackingFinanceReturn() {
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tLong = _useTranslation.tLong;
  var _useTrackingReturnWiz = useTrackingReturnWizard(),
    orderData = _useTrackingReturnWiz.orderData,
    goToStep = _useTrackingReturnWiz.goToStep;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: true,
    hideAppBanner: true,
    mobileNoLogo: true,
    hideHeaderOnmobile: true
  }, /*#__PURE__*/React.createElement(DeskTopBlueMobileWhiteHeader, {
    className2: stl.customBackground,
    title: t("track_car_order", {
      ns: "web_tracking_finance"
    }),
    hasDeskTopBack: true,
    hideMobile: true,
    onClick: function onClick() {
      return navigateTo("/tracking-landing");
    }
  }), /*#__PURE__*/React.createElement("section", {
    className: stl.grid
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.card
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imageBox
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.returnImage,
    src: CDN_LINK + '/assets/images/tracking-details/guarantee.svg',
    alt: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.headerBox
  }, /*#__PURE__*/React.createElement("h2", {
    className: stl.header
  }, t("decision_matters", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.description
  }, tLong("tracking/return-confirm-description", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.returnButtonBox
  }, /*#__PURE__*/React.createElement("button", {
    className: stl.returnButton,
    onClick: function onClick() {
      if (isLoggedIn) {
        trackEvents("return_button_click", {
          order_id: "".concat(orderData.order_id)
        });
      }
      goToStep("form");
    }
  }, t("submit_return_request", {
    ns: "web_tracking"
  })))), /*#__PURE__*/React.createElement("section", {
    className: stl.anyQuestionBox
  }, /*#__PURE__*/React.createElement(AnyQuestion, null)))));
};
export default TrackingFinanceReturn;